module.exports = __webpack_public_path__ + "img/fbcgTitleBg.502d7642.png";